import React from 'react';
import { XIcon } from 'lucide-react';
import { failedAttempts } from '../data/content';
export function WhyFailed() {
  return <section className="bg-cream" data-id="element-182" data-mp="2xb7hq15hamyg">
      <div className="mx-auto max-w-4xl px-6 py-16 lg:py-24" data-id="element-183" data-mp="2xebpf8i5k0tv">
        <h2 className="font-display text-3xl font-semibold tracking-tight text-ink sm:text-4xl" data-id="element-184" data-mp="2imtazf4xyecm">
          Por qué lo que ya intentaste no funcionó
        </h2>
        <p className="mt-4 max-w-prose text-base leading-relaxed text-ink/65" data-id="element-185" data-mp="29mermlbjf9br">
          No te faltó disciplina. Te faltó atacar la causa real.
        </p>

        <ul className="mt-12" data-id="element-186" data-mp="2dpuj738r2jhl">
          {failedAttempts.map(item => <li key={item.title} className="grid gap-x-5 gap-y-2 border-t border-ink/10 py-6 sm:grid-cols-[auto_14rem_1fr] sm:items-baseline" data-id="element-187" data-mp="1zq1wrk49apff">
              <span className="mt-1 flex h-6 w-6 items-center justify-center rounded-full bg-clay/10 sm:mt-0" data-id="element-188" data-mp="3u3t4ge30yz88">
                <XIcon className="h-3.5 w-3.5 text-clay" aria-hidden="true" data-id="element-189" data-mp="2v5l23ochm3b" />
              </span>
              <h3 className="font-display text-lg font-semibold text-ink" data-id="element-190" data-mp="1cl8nte8czqoe">
                {item.title}
              </h3>
              <p className="text-base leading-relaxed text-ink/70" data-id="element-191" data-mp="17n6xq9cimr3f">
                {item.text}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}